module.exports = __webpack_public_path__ + "static/media/img-problem@2x.55592c95.png";